// Side-track levels have a letter after the number (3a, 3b).
export const isSideTrack = (identifier) => /^\d+[a-z]$/.test(identifier);

// The main-track level number a gymnast is working on: one past their highest
// completed main-track level, or 1 if they haven't completed any.
export function currentLevelNumber(gymnast) {
  const completed = (gymnast?.levelProgress || [])
    .filter(lp => lp.status === 'COMPLETED' && lp.level)
    .map(lp => lp.level)
    .filter(level => !isSideTrack(level.identifier))
    .map(level => parseInt(level.identifier, 10))
    .filter(Number.isFinite);
  return completed.length ? Math.max(...completed) + 1 : 1;
}

// The level object for that number, or null when there isn't one (for
// example when every level is complete).
export const currentLevel = (gymnast, levels) => {
  const n = currentLevelNumber(gymnast);
  return (levels || []).find(l => !isSideTrack(l.identifier) && parseInt(l.identifier, 10) === n) || null;
};
